<template>
  <div class="live-events-header-container">
    <div>
      <h2>Live Events</h2>
      Events within the last 24 hours will appear on each property timeline
    </div>
    <div>
      <div class="resolved-toggle">
        <v-btn
          text
          class="clear-btn"
          :disabled="disabled"
          @click="$emit('toggle-resolved')"
        >
          <span>{{ resolvedVisible ? 'Hide' : 'Show' }} Resolved Events</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LiveEventsHeader',
    props: {
      resolvedVisible: {
        type: Boolean,
        default: true,
      },
      disabled: {
        type: Boolean,
        default: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
.live-events-header-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
}
.legend-item {
    white-space: nowrap;
}
.legend-item + .legend-item {
    margin-left: 38px;
}
.legend-item__swatch {
    display: inline-block;
    vertical-align: middle;
    height: 16px;
    width: 16px;
    margin-right: 10px;
}
.legend-item__label {
    white-space: nowrap;
}
.resolved-toggle {
  text-align: right;
  margin-top: 9px;
  margin-bottom:20px;
  & > button {
    text-transform: uppercase;
    font-family: 'Degular', sans-serif;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 1px;
    line-height: 20px;
    &:disabled {
      span {
        color: grey !important;
      }
    }
    span {
      color:$muted !important;
    }
  }
}
</style>
